import type { InventoryCostCheck } from './inventory-cost-check.js';

export type CostCheckFields = {
  farFromStandardTagCount: number;
  costedTagCount: number;
  stockedTagCount: number;
  stdCost: number | null;
};

export function itemMatchesCostCheck(item: CostCheckFields, check: InventoryCostCheck): boolean {
  switch (check) {
    case 'FAR':
      return item.farFromStandardTagCount > 0;
    case 'UNPRICED':
      return item.costedTagCount < item.stockedTagCount;
    case 'NO_STANDARD':
      return item.stockedTagCount > 0 && (item.stdCost === null || item.stdCost <= 0);
  }
}
